export const StreakSafeBanner = ({ showStreakSafe, setShowStreakSafe }) => {
  if (!showStreakSafe) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[150] animate-slide-in bg-gradient-to-r from-lime-600 to-green-600 border-b-4 border-lime-400 px-4 py-3 shadow-2xl">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1">
          <div className="text-2xl">✅</div>
          <div className="flex-1">
            <p className="text-white font-black text-sm sm:text-base uppercase leading-tight">
              STREAK SAFE UNTIL TOMORROW MIDNIGHT
            </p>
            <p className="text-lime-100 text-xs font-bold">
              Go do something stupid. You're covered.
            </p>
          </div>
        </div>
        <button
          onClick={() => setShowStreakSafe(false)}
          className="text-white hover:text-black font-black text-xl transition-all"
        >
          ✕
        </button>
      </div>
    </div>
  );
};
